import MuiList, { ListProps } from "@material-ui/core/List";
import * as React from "react";

export const List: React.FC<ListProps> = ({ children, ...rest }) => (
  <MuiList {...rest}>{children}</MuiList>
);
